/**
 * Redux store configuration with redux-thunk middleware.
 *
 * @module store
 * @author Snowfly
 * @version 1.0.0
 */
import {createStore, applyMiddleware, compose} from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './rootReducer';

/**
 * Configured Redux store instance with thunk middleware applied.
 *
 * @type {import('redux').Store}
 */
const store = createStore(
    rootReducer,
    compose(
        applyMiddleware(thunk),
    ),
);

export default store;
